export enum GoogleButtonSize {
	MEDIUM = 'medium',
	LARGE = 'large',
}